import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Calendar, Map, ShieldCheck, ArrowRight } from "lucide-react";
import sgeScreen from "../imagem/sge_logo_gold.webp";

function SGEPreview() {
  return (
    <section className="sge-preview-home py-20 bg-black-glass overflow-hidden">
      <Container>
        <Row className="align-items-center g-5">
          <Col lg={6} data-aos="fade-right">
             <div className="sge-preview-badge mb-4">DESTAQUE TECNOLÓGICO</div>
             <h2 className="display-4 fw-900 text-white mb-4">
                Conheça o <span className="text-gold">SGE Pro</span>
             </h2>
             <p className="lead-soft mb-5">
                A plataforma definitiva para gestão de logística em eventos de grande porte. 
                De mapas interativos de stands a cronogramas de montagem automatizados.
             </p>
             
             <div className="preview-features-mini mb-10">
                <div className="d-flex align-items-center gap-3 mb-3">
                   <div className="mini-icon-box"><Map size={18} /></div>
                   <span className="small-elite">Mapa de Stands 360°</span>
                </div>
                <div className="d-flex align-items-center gap-3 mb-3">
                   <div className="mini-icon-box"><Calendar size={18} /></div>
                   <span className="small-elite">Calendário Dinâmico de Ocupação</span>
                </div>
                <div className="d-flex align-items-center gap-3">
                   <div className="mini-icon-box"><ShieldCheck size={18} /></div>
                   <span className="small-elite">Segurança e Governança Enterprise</span>
                </div>
             </div>

             <Button href="/sge-pro" className="btn-gold-elite px-5 py-3">
                Explorar Sistema Completo <ArrowRight size={18} className="ms-2" />
             </Button>
          </Col>
          
          <Col lg={6} data-aos="fade-left">
             <div className="sge-mockup-wrapper">
                <div className="mockup-glow"></div>
                <img src={sgeScreen} alt="SGE Pro Teaser" className="img-fluid mockup-image-home" />
             </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .sge-preview-home {
           position: relative;
           border-top: 1px solid rgba(255,255,255,0.05);
           border-bottom: 1px solid rgba(255,255,255,0.05);
        }

        .bg-black-glass {
           background: rgba(5, 5, 5, 0.4);
           backdrop-filter: blur(20px);
        }

        .sge-preview-badge {
           display: inline-block;
           padding: 0.4rem 1.2rem;
           background: rgba(228,168,122,0.1);
           border: 1px solid rgba(228,168,122,0.3);
           color: var(--elite-gold);
           font-size: 0.7rem;
           font-weight: 800;
           letter-spacing: 2px;
           border-radius: 50px;
        }

        .lead-soft {
           color: #888;
           font-size: 1.15rem;
           line-height: 1.8;
        }

        .mini-icon-box {
           width: 38px; height: 38px;
           background: rgba(228,168,122,0.1);
           color: var(--elite-gold);
           display: flex; align-items: center; justify-content: center;
           border-radius: 10px;
        }

        .small-elite {
           font-weight: 700;
           font-size: 0.85rem;
           color: #aaa;
           letter-spacing: 0.5px;
        }

        .sge-mockup-wrapper {
           position: relative;
           padding: 2rem;
        }

        .mockup-image-home {
           border-radius: 24px;
           box-shadow: 0 40px 100px rgba(0,0,0,0.8);
           border: 1px solid rgba(255,255,255,0.05);
           transition: transform 0.6s ease;
        }

        .sge-mockup-wrapper:hover .mockup-image-home {
           transform: scale(1.02) rotate(-1deg);
        }

        .mockup-glow {
           position: absolute; top: 0; left: 0; width: 100%; height: 100%;
           background: radial-gradient(circle, rgba(228,168,122,0.1), transparent 70%);
           z-index: -1;
        }

        .btn-gold-elite {
           background: var(--elite-gold);
           color: #000 !important;
           border: none;
           font-weight: 800;
           text-transform: uppercase;
           letter-spacing: 2px;
           border-radius: 12px;
           transition: all 0.4s ease;
           box-shadow: 0 15px 40px rgba(228, 168, 122, 0.3);
        }

        .btn-gold-elite:hover {
           background: #fff;
           transform: translateY(-5px);
           box-shadow: 0 25px 60px rgba(228, 168, 122, 0.5);
        }
      `}</style>
    </section>
  );
}

export default SGEPreview;
